export default {
  default: () => import("F:/webroot/abuy.ilovearomagrace.com/layouts/default.vue").then(m => m.default || m),
  none: () => import("F:/webroot/abuy.ilovearomagrace.com/layouts/none.vue").then(m => m.default || m)
}